/**
 * Message d'erreur de l'API en texte, pour un Error (dont `message` doit être une chaîne) : getErrorMessage de
 * finances-utils renvoie un élément React, qui donnerait « [object Object] ». L'API renvoie une liste d'erreurs
 * ({ code, message }[]) ou une erreur ({ message }) ; sinon, le message par défaut.
 *
 * @param separateur entre les messages d'une liste d'erreurs : '\n' pour un affichage sur plusieurs lignes
 */
const getMessageErreur = (
	erreur: unknown,
	messageParDefaut: string,
	separateur = ' ',
): string => {
	const donnees = (erreur as { response?: { data?: unknown } })?.response?.data;
	const messages = (Array.isArray(donnees) ? donnees : [donnees])
		.map((donnee) => (donnee as { message?: unknown })?.message)
		.filter(
			(message): message is string =>
				typeof message === 'string' && message !== '',
		);

	return messages.length > 0 ? messages.join(separateur) : messageParDefaut;
};

export default getMessageErreur;
